import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMapTelemetry } from 'browser/map-search/services/mapTelemetry';
import { closeChatModal } from 'shared/map-search/actions/chatModal';
import { ChatModal } from 'shared/map-search/components/ChatModal';
import { ChatModalOwnOffer } from 'shared/map-search/components/ChatModalOwnOffer/ChatModalOwnOffer';
import {
  selectIsChatModalOpen,
  selectOfferChatAuthorId,
  selectOfferChatGaLabel,
  selectOfferChatProduct,
} from 'shared/map-search/selectors/chatModal';
import { selectOfferChatIsDotPin } from 'shared/map-search/selectors/chatModal/selectOfferChatIsDotPin';
import { selectUserId } from 'shared/map-search/selectors/user';

import { useSrcChat } from './hooks';
import { trackModalOpen } from './utils/tracking';

export const ChatModalContainer = () => {
  const dispatch = useDispatch();

  const gaLabel = useSelector(selectOfferChatGaLabel);
  const isOpen = useSelector(selectIsChatModalOpen);

  const authorId = useSelector(selectOfferChatAuthorId);
  const userId = useSelector(selectUserId);
  const product = useSelector(selectOfferChatProduct);
  const isDotPin = useSelector(selectOfferChatIsDotPin);
  const src = useSrcChat(isOpen);

  const onOpen = React.useCallback(() => {
    trackModalOpen(gaLabel, product, isDotPin);
  }, [gaLabel, product, isDotPin]);

  const onClose = React.useCallback(() => {
    dispatch(closeChatModal());
  }, [dispatch]);

  const isOwnOffer = Boolean(authorId && userId && authorId === userId);

  React.useEffect(() => {
    if (!isOpen) {
      return;
    }

    const mapTelemetry = getMapTelemetry();

    mapTelemetry.trackChatAttempt();

    /**
     * Без адреса ChatModal рендерит null: модалка открыта, а пользователь не видит ничего.
     * В SOPR это выглядит как обычное открытие, потому что trackModalOpen срабатывает раньше
     * проверки адреса, — значит увидеть такой сбой можно только отсюда.
     *
     * На собственном объявлении чата и не должно быть, там показывается заглушка, поэтому
     * эту ветку в отказ не записываем.
     */
    if (!isOwnOffer && !src) {
      mapTelemetry.trackChatNoSource();
    }

    /** Считаем одно открытие один раз: src и признак своего объявления меняются внутри открытия */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  if (isOwnOffer) {
    return <ChatModalOwnOffer isOpen={isOpen} onClose={onClose} />;
  }

  return <ChatModal isOpen={isOpen} src={src} onClose={onClose} onOpen={onOpen} />;
};
